import { useSession } from '@side/next-auth/react';
import { useIsMobile } from '@side/pantry';
import { useCore, useIdentity } from '$api-clients/hooks';

const progressReportNames = ['Pricing Plan Progress'];

export function useReports() {
  const isMobile = useIsMobile();
  const userId = useSession().data?.user?.id;

  const { data, isLoading: reportsLoading } = useCore(
    '/users/me/reports',
    undefined,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  const reports = data ?? [];

  const progressReportIndex = reports.findIndex((r) =>
    progressReportNames.includes(r.name),
  );

  const { data: membersData, isLoading: teamMembersLoading } = useIdentity(
    '/team-members',
    userId && progressReportIndex !== -1
      ? {
          params: {
            query: {
              userIds: userId,
              search:
                'status^("ACTIVE","OFFBOARDING") AND user.status:"ACTIVE"',
              limit: 1,
            },
          },
        }
      : null,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  const teamId = membersData?.data[0]?.team.id;

  if (progressReportIndex !== -1 && teamId) {
    reports[progressReportIndex] = {
      ...reports[progressReportIndex],
      mobile: true,
      desktop: true,
      url: `${window.location.origin}/payment/team/${teamId}/report/pricing-plan-progress?embedded=true`,
    };
  }

  return {
    reports: reports.filter(({ desktop, mobile }) =>
      isMobile ? mobile : desktop,
    ),
    loading: reportsLoading || teamMembersLoading,
  };
}
